module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/mceltis8-881534b1cbdf04e8f0f6112697d10c2e.jpg";